<template>
  <el-form ref="form" class="table_form" :model="ruleForm" style="height:100% !important">
    <el-table
      ref="table"
      :data="ruleForm.data"
      :row-class-name="tableRowClassName"
      :row-style="showRow"
      @row-click="rowClick"
      border
      height="100%"
    >
      <el-table-column width="100" align="center" v-if="!innerLineEdit">
        <template slot-scope="scope">
          <el-radio
            v-if="isHide(scope.row)"
            class="tableRadio"
            :label="scope.row.id"
            v-model="templateRadio"
          ></el-radio>
        </template>
      </el-table-column>

      <el-table-column
        v-for="(column,index) in columns"
        :key="column.value"
        :label="column.text"
        :prop="column.value"
        :width="column.width"
        :align="setAlign(column.icon)"
        show-overflow-tooltip
      >
        <template v-slot="scope">
          <div v-if="column.icon">
            <span
              v-if="showExpanded(index,scope.row)"
              :style="setIconStyle(scope.row._level)"
              @click="expanded(scope.row)"
            >
              <i v-if="scope.row._expanded" class="el-icon-arrow-down"/>
              <i v-else class="el-icon-arrow-right"/>
            </span>
            <div
              v-if="scope.row._edit&&column.type"
              class="editDiv"
              fixed="right"
              :style="setWidth(column.width,scope.row._level)"
            >
              <el-form-item
                :prop="`data.${scope.$index}.`+[column.value]"
                :rules="rules[parentCode]"
                style="margin-bottom: 0px !important"
              >
                <el-input @blur="checkTable(column.value)" v-model="scope.row[column.value]"></el-input>
              </el-form-item>
            </div>
            <div v-else class="textDiv">
              <span
                v-text="scope.row[column.value]"
                :style="setWidth(column.width,scope.row._level)"
              ></span>
            </div>
          </div>
          <div v-else>
            <div v-if="scope.row._edit&&column.type">
              <el-form-item
                :prop="`data.${scope.$index}.`+[column.value]"
                style="margin-bottom: 0px !important"
                :rules="column.rule"
              >
                <el-input
                  v-if="column.type==='el-input'"
                  @blur="checkTable(column.value)"
                  v-model="scope.row[column.value]"
                ></el-input>

                <el-select
                  v-else-if="column.type==='el-select'&&column.value==='status'"
                  @change="statusChange(scope.row,value)"
                  v-model="scope.row[column.value]"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-select
                  v-else-if="column.type==='el-select'"
                  v-model="scope.row[column.value]"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in column.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </div>
            <div v-else class="textDiv">
              <span v-if="column.options">
                <span v-if="column.value==='status'">
                  <span v-for="item in statusOptions" :key="item.value">
                    <span v-if="scope.row[column.value]===item.value">
                      <span v-if="isHide(scope.row)">
                        <el-tag
                          :type="item.value=='1'?'success':'danger'"
                          v-if="scope.row.status==item.value"
                        >{{item.label}}</el-tag>
                      </span>
                    </span>
                  </span>
                </span>
                <span v-else>
                  <span v-for="item in column.options" :key="item.value">
                    <span v-if="scope.row[column.value]===item.value">
                      <span v-if="isHide(scope.row)" v-text="item.label"></span>
                    </span>
                  </span>
                </span>
              </span>
              <span v-else-if="isHide(scope.row)" v-text="scope.row[column.value]"></span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" label="操作" min-width="100">
        <template v-slot="scope">
          <span v-if="innerLineEdit&&isHide(scope.row) && !projectStructurData != '2'">
            <el-tooltip effect="dark" content="新增" placement="top">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-plus"
                style="color:green"
                buttonCode="TY017"
                @click.stop="handleNewRow(scope.$index,scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="删除" placement="top">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                style="color:red"
                buttonCode="TY011"
                @click.stop="handleRowDelete(scope.row,scope.$index)"
              ></el-button>
            </el-tooltip>
          </span>
          <span v-else-if="isHide(scope.row) && projectStructurData != '2'">
            <el-tooltip effect="dark" content="新增" placement="top">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-plus"
                style="color:green"
                v-if="customization.plus"
                @click.stop="handleAdd(scope.row)"
                buttonCode="TY017"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="编辑" placement="top">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                style="color:#409EFF"
                buttonCode="TY010"
                @click.stop="handleEdit(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="删除" placement="top">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                style="color:red"
                buttonCode="TY011"
                @click.stop="handleDelete(scope.row,scope.$index)"
              ></el-button>
            </el-tooltip>
          </span>
          <span v-if="projectStructurData == '2'">
            <el-tooltip effect="dark" content="新增" placement="top">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-plus"
                style="color:green"
                buttonCode="TY017"
                v-if="customization.plus && scope.row.isStructure !== '0' "
                @click.stop="handleAdd(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="编辑"
              placement="top"
              v-if="scope.row.isStructure === '1'"
            >
              <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                style="color:#409EFF"
                buttonCode="TY010"
                @click.stop="handleEdit(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="删除"
              placement="top"
              v-if="scope.row.isStructure === '1'"
            >
              <el-button
                size="mini"
                type="text"
                icon="el-icon-delete"
                style="color:red"
                buttonCode="TY011"
                @click.stop="handleDelete(scope.row,scope.$index)"
              ></el-button>
            </el-tooltip>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>
<script>
export default {
  name: "treeTable",
  props: {
    projectStructurData: {
      type: String,
      default: null
    },
    data: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    hideByProperty: {
      type: String,
      default: null
    },
    innerLineEdit: {
      type: Boolean,
      default: false
    },
    customization: {
      type: Object,
      default: () => {
        return {
          plus: true
        };
      }
    },
    parentCode: {
      type: String,
      default: null
    },
    distinguish: {
      type: String,
      default: null
    },
    condition: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    var checkCode = (rule, value, callback) => {
      if (value === "" || value === null) {
        this.$message.error("编码不能为空");
        callback(new Error(""));
      } else {
        let number = 0;
        this.ruleForm.data.forEach(item => {
          if (value === item[this.parentCode]) {
            number++;
          }
        });
        if (number > 1) {
          this.$message.error("该编码已经存在");
          callback(new Error(""));
        } else {
          let guid;
          let parentCode;
          this.ruleForm.data.forEach(item => {
            if (value === item[this.parentCode]) {
              guid = item._parentGuid;
            }
          });
          this.ruleForm.data.forEach(item => {
            if (guid === item._guid) {
              parentCode = item[this.parentCode];
            }
          });
          if (
            parentCode != undefined &&
            (value.length <= parentCode.length ||
              value.substr(0, parentCode.length) != parentCode)
          ) {
            this.$message.error("子级必须以父级编码为起始");
            callback(new Error(""));
          } else {
            callback();
          }
        }
      }
    };
    return {
      show: true,
      tmp: [],
      templateRadio: "",
      ruleForm: {
        data: []
      },
      rules: {
        [this.parentCode]: [
          {
            validator: checkCode,
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    data() {
      this.handleData(false);
    }
  },
  computed: {
    statusOptions() {
      return this.$prompts.status();
    }
  },
  mounted() {
    if (
      this.data.length == 0 &&
      this.ruleForm.data.length == 0 &&
      this.innerLineEdit
    ) {
      let defaultRow = {};
      this.columns.forEach(column => {
        if(column.value!=this.parentCode){
        this.$set(this.rules,column.value,column.rule)
      }
        if (column.value === "status") {
          this.$set(defaultRow, column.value, "1");
        } else {
          this.$set(defaultRow, column.value, "");
        }
      });
      this.data.push(defaultRow);
    } else {
      this.handleData(false);
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      let classname = "";
      row._show && row._search ? "" : (classname += "displayRow ");
      //"displayRow "空格不能丢
      if (row.isStructure === "0") {
        classname += "warning-row";
      }
      if (
        row[this.distinguish] == 0 &&
        this.$route.path == "/module/system/subjectArchive/subjectArchiveList"
      ) {
        classname += "warning-row";
      }
      return classname;
    },
    judageExpand() {
      for (let index = 0; index < this.data.length; index++) {
        const item = this.data[index];
        if (item._expanded == true) {
          this.handleData(false);
          return false;
        }
      }
      this.handleData(true);
    },
    handleData(expand) {
      if (
        this.data.length == 0 &&
        this.ruleForm.data.length == 0 &&
        this.innerLineEdit
      ) {
        let defaultRow = {};
        this.columns.forEach(column => {
          if (column.value === "status") {
            this.$set(defaultRow, column.value, "1");
          } else {
            this.$set(defaultRow, column.value, "");
          }
        });
        this.data.push(defaultRow);
      } else {
        this.ruleForm.data = this.formatData(this.data, expand, 1, 0);
        this.$refs["table"].doLayout();

        // this.handleCondition();
      }
    },
    // handleCondition() {
    //   if (this.isCondition()) {
    //     this.matchData(this.data, this.condition)
    //   } else {
    //     this.ruleForm.data = this.formatData(this.data, false, 1, 0)
    //   }
    // },
    formatData(data, expandAll, level, rowIndex, guid) {
      let tmp = [];
      data.forEach(item => {
        if (item._guid == undefined) {
          this.$set(item, "_guid", this.guid());
        }
        if (item._expanded == undefined || item._expanded != expandAll) {
          this.$set(item, "_expanded", expandAll);
        }
        if (item._level == undefined) {
          this.$set(item, "_level", level);
        }
        if (item._edit == undefined && this.innerLineEdit) {
          this.$set(item, "_edit", true);
        }
        if (item._search == undefined) {
          this.$set(item, "_search", false);
        }
        if (item._show == undefined) {
          this.$set(item, "_show", false);
        }
        if (guid !== undefined && guid !== null) {
          this.$set(item, "_parentGuid", guid);
        }
        this.isCondition(item);
        tmp.push(item);
        if (item.children && item.children.length > 0) {
          const children = this.formatData(
            item.children,
            item._expanded,
            level + 1,
            rowIndex,
            item._guid
          );
          tmp = tmp.concat(children);
          let a = item.children.find(element => {
            return element._search == true;
          });
          if (a != undefined) {
            item._search = true;
          }
        }
        //是否显示
        if (level === 1 && item._search) {
          item._show = true;
        } else if (item._expanded && item._search) {
          item._show = true;
        } else {
          item._show = false;
        }
      });
      return tmp;
    },
    isCondition(item) {
      let conditionNull = true;
      let equal = true;
      for (const key in this.condition) {
        if (this.condition.hasOwnProperty(key)) {
          const element = this.condition[key];
          let tt = item.templateName;
          if (element !== "" && element !== null) {
            conditionNull = false;
            if (key == "status") {
              equal = equal && element === item[key];
            } else if (typeof element === "number") {
              equal = equal && element === item[key];
            } else if (typeof element === "string") {
              equal = equal && item[key].includes(element);
            }
          }
        }
      }
      if (conditionNull) {
        item._search = true;
        //如果为空
      } else {
        if (equal) {
          if (
            item[this.distinguish] == undefined ||
            item[this.distinguish] == 1
          ) {
            item._search = true;
          } else {
            item._search = false;
          }
          //如果相等
        } else {
          item._search = false;
        }
      }
      //如果item和这个条件相等
      //不等
    },
    matchData(data, condition) {
      data.forEach(item => {
        let bol = false;
        if (item.children && item.children.length > 0) {
          this.matchData(item.children, condition);
          let a = item.children.find(item => {
            return item._show == true;
          });
          if (a != undefined) {
            bol = true;
            item._expanded = true;
          }
        }
        if (!bol) {
          let bol2 = true;
          for (const key in condition) {
            if (condition.hasOwnProperty(key)) {
              const element = condition[key];
              if (element) {
                bol2 = bol2 && item[key] === element;
              }
            }
          }
          bol = bol2;
        }
        item._show = bol;
      });
    },
    handleEdit(row) {
      this.templateRadio = row.id;
      this.$emit("handleEdit", row);
    },
    handleAdd(row) {
      this.templateRadio = row.id;
      if (row.status === "0") {
        this.$message.error("启用状态为禁用时，不可新增下级。");
      } else {
        this.$emit("handleAdd", row.id);
      }
    },
    handleRowDelete(row, index) {
      if (row.children && row.children.length > 0) {
        this.$message.error("存在下级节点不能删除");
      } else {
        this.ruleForm.data.splice(index, 1);
        this.ergodicTreeDelete(this.data, row._guid);
      }
    },
    handleDelete(row, index) {
      if (row.children && row.children.length > 0) {
        this.$message.error("存在下级节点不能删除");
      } else {
        this.$emit("handleDelete", row.id);
        this.$emit("handleRowDelete", row);
      }
    },
    ergodicTreeDelete(val, guid) {
      val.forEach((item, index) => {
        if (item._guid === guid) {
          val.splice(index, 1);
        }
        if (item.children) {
          this.ergodicTreeDelete(item.children, guid);
        }
      });
    },
    setFixed(icon) {
      if (icon) {
        return "left";
      }
    },
    setAlign(icon) {
      if (icon) {
        return "left";
      } else {
        return "center";
      }
    },
    handleEidtSave(index, row) {
      row._edit = false;
    },
    showExpanded(index, row) {
      if (row.children && row.children.length > 0) {
        let val = row.children.find(item => {
          return item._search == true;
        });
        if (val === undefined) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    expanded(row, data) {
      if (!data) {
        row._expanded = !row._expanded;
      } else {
        row._expanded = data;
      }
      if (row._expanded) {
        row.children.forEach(item => {
          if (item._search) {
            item._show = true;
          }
        });
      } else {
        this.ergodicTree(row.children, "_show", false);
        this.ergodicTree(row.children, "_expanded", false);
      }
      this.$nextTick(() => {
        this.$refs["table"].doLayout();
      });
    },
    ergodicTree(val, column, data) {
      val.forEach(item => {
        item[column] = data;
        if (item.children) {
          this.ergodicTree(item.children, column, data);
        }
      });
    },
    setIconStyle(level) {
      return {
        position: "absolute",
        top: 25 + "%",
        paddingLeft: 25 * (level - 1) + "px",
        cursor: "pointer"
      };
    },
    isHide(row) {
      if (
        (this.hideByProperty != null && row[this.hideByProperty] === 0) ||
        (row.isStructure == "0" &&
          this.$route.path ==
            "/module/system/projectApproval/ProjectStructure/ProjectStructureList")
      ) {
        return false;
      } else {
        return true;
      }
    },
    setWidth(width, level) {
      return {
        width: 100 + "%",
        paddingLeft: 25 * level + "px"
      };
    },
    showRow({ row, rowIndex }) {
      return row._show && row._search ? "" : "display: none";
      this.$refs["table"].doLayout();
    },
    rowClick(row) {
      if (row[this.hideByProperty] !== 0) {
        this.templateRadio = row.id;
        this.$emit("rowClick", row);
      }
    },
    statusChange(row, val) {
      this.ergodicTree(row.children, "status", row.status);
    },
    handleNewRow(index, row) {
      //编码为空
      if (row.status === "0") {
        this.$message.error("启用状态为禁用时，不可新增下级。");
      } else if (row[this.parentCode] === "") {
        this.$message.error("编码不能为空");
      } else {
        let number = 0;
        this.ruleForm.data.forEach(item => {
          if (row[this.parentCode] === item[this.parentCode]) {
            number++;
          }
        });
        if (number > 1) {
          this.$message.error("编码存在重复");
        } else {
          let parentCode;
          this.ruleForm.data.forEach(item => {
            if (item._guid === row._parentGuid) {
              parentCode = item[this.parentCode];
            }
          });
          if (
            parentCode != undefined &&
            (row[this.parentCode].length <= parentCode.length ||
              row[this.parentCode].substr(0, parentCode.length) != parentCode)
          ) {
            this.$message.error("子级必须以父级编码为起始");
          } else {
            let data = {
              id: "",
              parentId: row.id,
              _show: "",
              _expanded: "",
              _level: row._level + 1,
              _edit: true,
              _search: true,
              _guid: this.guid(),
              _parentGuid: row._guid
            };
            this.columns.forEach(column => {
              if (column.value === "status") {
                this.$set(data, column.value, "1");
              } else if (column.value === this.parentCode) {
                this.$set(data, column.value, row[this.parentCode]);
              } else {
                this.$set(data, column.value, "");
              }
            });

            if (row.children == null) {
              row.children = [];
            }
            this.ruleForm.data.splice(index + 1, 0, data);
            row.children.push(data);
            this.expanded(row, true);
            this.$emit("handleNewRow", data);
          }
        }
      }
    },
    checkTable(columnValue) {
      this.$refs.form.validateField(columnValue);
    },
    getForm() {
      return this.$refs.form;
    },
    guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    clearTable() {
      this.ruleForm.data = [];
      this.templateRadio = "";
    }
  }
};
</script>
<style scoped lang="scss">
.editDiv {
  display: inline-block;
}

.textDiv {
  display: inline;
}
/* .innerEdit{ 
  margin-bottom: 0px !important
} */
.tableRadio /deep/ .el-radio__label {
  display: none !important;
}
/deep/ .el-table .warning-row {
  background: #f5f7fa;
}
/deep/ .displayRow {
  display: none;
}

/*.el-table .success-row {*/
/*background: #f0f9eb;*/
/*}*/
</style>
<style lang="scss" scoped>
.table_form{
  height:100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/treeGrid/treeTable.vue